import { CurrencyPipe } from '@angular/common';
import { Component, Input, OnChanges, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatOption } from '@angular/material/core';
import { Params, Router } from '@angular/router';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import Swal from 'sweetalert2';
import { FeeConfigService } from '../../fee-config.service';
import { DialogComponent } from 'src/app/features-common/components/dialog/dialog.component';
import { MatDialog } from '@angular/material/dialog';


@Component({
  selector: 'app-add-fee',
  templateUrl: './add-fee.component.html',
  styleUrls: ['./add-fee.component.scss'],
  providers: [CurrencyPipe]
})
export class AddFeeComponent extends FeaturesBaseComponent implements OnInit, OnDestroy {
  feeConfigForm: FormGroup;

  constructor(private fb: FormBuilder, private router: Router, private feeConfigService: FeeConfigService ,public dialog: MatDialog) {
    super();
    this.feeConfigForm = this.fb.group({
      paymentType: ['', [Validators.required]],
      feeType: ['', [Validators.required]],
      feeAmount: ['', [Validators.required]],
      startDate: ['', [Validators.required]],
      endDate: ['', [Validators.required]],
    })

  }


  ngOnInit(): void {

  }

  onSubmit() {
    if (this.feeConfigForm.valid) {
      const dialogRef = this.dialog.open(DialogComponent, {
        data: {
          message: 'pages.placeholders.Areyousureyouwanttosavethechanges',
          buttonText: {
            ok: 'pages.placeholders.Save',
            cancel: 'pages.placeholders.cancel'
          }
        }
      });

      dialogRef.afterClosed().subscribe((confirmed: boolean) => {
        if (confirmed) {
          this.setSubmitParameters(this.feeConfigForm)
        }else{
          this.router.navigate([`features/consumers/fee-config/all-fee`])
        }
      });

    }
  }

  setSubmitParameters(feeConfigForm: FormGroup) {
    let httpParams: Params = {
      paymentType: feeConfigForm.get('paymentType').value,
      feeType: feeConfigForm.get('feeType').value,
      feeValue: feeConfigForm.get('feeAmount').value,
      validityStartDttm: feeConfigForm.get('startDate').value.toISOString().slice(0, 10),
      validityEndDttm: feeConfigForm.get('endDate').value.toISOString().slice(0, 10),
    }
    this.feeConfigService.addFeeConfig(httpParams).subscribe(res => {
        if (res && res) {
          if(res.httpcode == 200 || res.responseStatus == 'Success'){
            this.router.navigate([`features/consumers/fee-config/all-fee`])
            this.toastrService.success('Fee Added successfully', 'Success', {
              timeOut: 3000,
            });        
        }
      }
    });
  }


  onCancel() {
    for (const name in this.feeConfigForm.controls) {
      if (this.feeConfigForm.controls[name].invalid) {
       
      } else {
       
      }
    }

    const dialogRefCancel = this.dialog.open(DialogComponent, {
      data: {
        message: 'pages.placeholders.Areyousureyouwanttocancelthechanges',
        buttonText: {
          ok: 'pages.newRetailer.yes',
          cancel: 'pages.newRetailer.cancel'
        }
      }
    });

    dialogRefCancel.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.router.navigate([`features/consumers/fee-config/all-fee`])
      }
    });
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }  
}
 
